import { render, staticRenderFns } from "./gcscc-match-users.vue?vue&type=template&id=dfaa1bb2&scoped=true&"
import script from "./gcscc-match-users.vue?vue&type=script&lang=js&"
export * from "./gcscc-match-users.vue?vue&type=script&lang=js&"
import style0 from "./gcscc-match-users.vue?vue&type=style&index=0&id=dfaa1bb2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfaa1bb2",
  null
  
)

export default component.exports